<template>
  <v-container  class="h-100 " >
    <v-row no-gutters class="h-100">
      <v-col class="h-100" style="overflow-y: scroll">
        <v-data-table
                :loading="loading"
                :headers="fields"
                :items="Items"
                item-key="id"
                no-data-text="Нет элементов"
                no-results-text="Не найдено"
                loading-text="Загрузка данных"
                calculate-widths
                :items-per-page="Items.length"
                class="elevation-1"
                :search="search"
                fixed-header
                sort-by="requestDateTime"
                sort-desc
                height="100%"
                hide-default-footer
                @click:row="showDetailModal"
        >
          <template v-slot:item.isRead="{ item }">
            <div v-if="item.isRead==false" class="markNotRead"></div>
          </template>
          <template v-slot:item.requestNumber="{ item }">
            <span :class="{'readRow':item.isRead, 'newRow':true}"> {{item.requestNumber}}</span>
          </template>
          <template v-slot:item.carName="{ item }">
            <span :class="{'readRow':item.isRead, 'newRow':true}"> {{ item.carMarkName+' '+item.carModelName +', '+ item.carYear}}</span>
          </template>

          <template v-slot:item.requestDateTime="{ item }">
            <span :class="{'readRow':item.isRead,'newRow':true}"> {{ formatTimeDateMounthName(item.requestDateTime) }}</span>
          </template>
          <template v-slot:item.clientFullName="{ item }">
            <span :class="{'readRow':item.isRead,'newRow':true}"> {{ item.clientFullName }}</span>
          </template>
          <template v-slot:item.requestCategoryName="{ item }">
            <span :class="{'readRow':item.isRead,'newRow':true}"> {{ item.requestCategoryName }}</span>
          </template>
          <template v-slot:item.serviceType="{ item }">
            <span :class="{'readRow':item.isRead,'newRow':true}"> {{ item.serviceType }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <detailsModal :show="showDetail" :detailedItem="detailedItem" @close="closeDetails"></detailsModal>
  </v-container>

</template>

<script>
  const detailsModal =()=> import('./DetailsRequest.vue')
    export default {
        name: "NewRequests",
        components:{detailsModal},
        props: {
            search: String
        },
        data() {
            return {
                loading:false,
                fields: [
                    {text: '№', value: 'requestNumber', width: "60px"},
                    {text: 'Создана', value: 'requestDateTime',width: "170px"},
                    {text: 'S', value: 'isRead', filterable: false, width: "60px", align: "center"},
                    {text: 'Клиент', value: 'clientFullName',width: "270px"},
                    {text: 'Транспортное средство', value: 'carName', width: "230px"},
                    {text: 'Категория заявки', value: 'requestCategoryName'},
                    {text: 'Тема обращения', value: 'serviceType'},
                ],
                requestAnswerModel: {
                    requestId: null,
                    textAnswer: null,
                    priceFrom: null,
                    priceTo: null,
                },
                showDetail: false,
                detailedItem: null,
            }
        },
        computed: {
            Items() {
                var items = this.$store.state.Requests.newRequests;
                if (items != null) {
                    return items
                }
                else return [];
            },

        },
        beforeMount() {
            this.loadData()
        },
        methods: {
            loadData(){
                const vm=this
                this.loading=true
                this.$store.dispatch("Requests/getRequests").then(()=>vm.loading=false)
                    .catch(err => {
                        vm.loading=false
                        this.$bvToast.toast(err.message, {
                            title: `Ошибка загрузки списка заявок!`,
                            variant: "danger",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                    })
            },
            closeDetails(isSave){
                this.showDetail=false
                if(isSave){
                    this.loadData()
                }
            },
            showDetailModal(e) {
                this.detailedItem = e;
                this.showDetail = true;
                //отправляем запрос на прочтение
                if (e.isRead == false) {
                    this.$store.dispatch("Requests/markReadRequest", e.id).catch(err => {
                        console.log("Ошибка прочтения заявки!")
                    })
                }
            },



        }
    }
</script>
<style>

</style>

<style scoped lang="scss" >
  @import '../../styles/variables';

  .rowTop{
  position: absolute;
  top:-50px;
}


.readRow{
  color:var(--color-2);
}

.newRow{
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}

  .markNotRead{
    border-radius: 50%;
    width: 10px;
    height: 10px;
    background-color: #27AE60;
  }

</style>
